import { useTranslation } from 'react-i18next'
import { TPatientMedEvent } from 'src/types/med-event'
import { TFollowup } from 'src/types/followup'
import { TPatientMedAlert } from 'src/types/med-alert'
import AllAppointments from './all-appointments.component'

const PastAppointment = ({
  patientMedEvents,
  patientMedAlerts,
  currentFollowup,
  currentPatientFollowupId,
}: {
  patientMedEvents: TPatientMedEvent[]
  patientMedAlerts: TPatientMedAlert[]
  currentFollowup: TFollowup
  currentPatientFollowupId: number
}) => {
  const { t } = useTranslation()
  const pastMedEvents = patientMedEvents
    ?.filter((medEvent) => new Date(medEvent.date) <= new Date())
    .filter((medEvent) => medEvent.date !== null)

  return (
    <AllAppointments
      patientMedEvents={pastMedEvents}
      patientMedAlerts={patientMedAlerts}
      currentFollowup={currentFollowup}
      currentPatientFollowupId={currentPatientFollowupId}
      title={t('components.patient.patient-file.body.followup-details.last-appointments')}
    />
  )
}

export default PastAppointment
